<style>
.v-input--selection-controls {
  margin-top: 0;
}

@font-face {
  font-family: "Bliss 2";
  src: url(./fonts/Bliss2/Bliss2R.otf) format("opentype");
}

@font-face {
  font-family: "Bliss 2";
  font-weight: bold;
  src:  url(./fonts/Bliss2/Bliss2B.otf) format("opentype");
} 

body, .v-application {
  font-family: "Bliss 2", Helvetica, Arial;
}

h1, h2, h3, h4, h5, h6 {
  font-family: "Bliss 2", Helvetica, Arial;
  font-weight: bold;
}  

.v-application button.primary:hover {
  background-color: #FFF !important;
  color: #DB4132 !important;
  border: 1px solid #DB4132;
  transition: .2s;
}

.hasValidationErrorIcon .v-input__prepend-inner {
  display: none !important;
}

.hasValidationErrorIcon.error--text.v-input--is-focused .v-input__prepend-inner {
  display: inline-block !important;
}

.hasValidationErrorIcon.error--text.v-input--is-focused .v-label {
  left: -25px !important;
}

.snackbar-error-message .v-snack__wrapper {
  background-color: #fde8e8 !important;
  border: none;
}

.snackbar-error-message .v-snack__content {
  color: #c40404 !important;
}

/* CSS class to be applied on hidden elements for screen reader use only */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-fieldset {
  border: none;
  margin: 0;
  padding: 0;
}

.content-item-list {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 8px;
}

.content-item-list dd {
  margin: 0;
}

.v-stepper__step--inactive .v-stepper__label h3,
.v-stepper__step--inactive .v-stepper__label .text-caption {
  color: #636363;
}

.v-stepper__step--inactive .v-stepper__step__step {
  background-color: #636363 !important;
}
</style>

<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <!--<v-app-bar-nav-icon
        @click.stop="sidebarMenu = !sidebarMenu"
      ></v-app-bar-nav-icon>-->
      <v-toolbar-title><h2>SEND YOUR ITEM</h2> </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn aria-label="Go to home page" icon>
        <v-img src="./assets/logo.png" width="50" height="50" contain @click="redirectToIntro()"></v-img>
      </v-btn>
    </v-app-bar>
    <!--<v-navigation-drawer
      v-model="sidebarMenu"
      app
      :permanent="sidebarMenu"
      :mini-variant.sync="mini"
      color="primary"
    >
      <v-list dense class="secondary">
        <v-list-item>
          <v-list-item-content>
            <v-img
              src="./assets/logo.png"
              width="100"
              height="100"
              contain
            ></v-img>
            <v-list-item-title></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.href"
        >
          <v-list-item-icon>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>-->
    <v-main>
      <v-container class="px-4 py-0 fill-height" fluid>
        <v-row class="fill-height">
          <v-col>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </v-col>
        </v-row>
      </v-container>
      <v-footer color="primary" class="py-3">
        <span class="overline white--text"
          >&copy; {{ year }} MaltaPost |
          <span v-if="!isMobile()">All rights reserved | </span>Version
          {{ version }}</span
        >
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>
import properties from "./assets/properties.json";
import router from './router'

export default {
  name: "App",

  components: {},

  data: () => ({
    sidebarMenu: false,
    items: [{ title: "Home", href: "/", icon: "mdi-home" }],
    year: new Date().getFullYear(),
    version: properties.ServiceComponentVersion,
    mini: false,
    toggleMini: false,
  }),
  methods: {
    isMobile() {
      if (window.innerWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    redirectToIntro: function() {
      router.push('/');
    },
  },
  created: function() {
    this.sidebarMenu = !this.isMobile();
  },
  mounted() {
    this.$store.dispatch("getSettings");
  },
};
</script>
